<template>
	<div class="commonModalBlo">
		<div class="commonModal modal">
			<div class="commonTitle">
				登录账号发生变更
			</div>

			<div class="commonCon">
				<div class="tips displayF">
					当前页面下存在其他账号在不同设备、浏览器发生了登录操作。请刷新以同步至最新登录账号。
				</div>
			</div>

			<div class="buttonBlo buttonBloP">
				<el-button @click="submitHandle()" type="primary" :loading="loading">
					{{getSureText('刷新页面(' + showNum + 's)', true)}}
				</el-button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		getSureText,
		setMessageQueue
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user.js'

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		showLogoutNum: {
			type: Number,
			default: 5
		}
	})
	
	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})
	const showNum = computed(() => {
		return props.showLogoutNum
	})
	
	const loading = ref(false)

	// 点击回车键
	function keyDown(e) {
		let shortcutModelArr = userConfigData.value.shortcutModelArr
		console.log(e, 'e keyDown document.activeElement', document.activeElement)
		// enter键的ASCII是13
		if (e.keyCode === 13) {
			if (shortcutModelArr.includes(2)) {
				e.preventDefault();
	
				// 20260303 新增 重复提交禁用
				if (loading.value) {
					return
				}
	
				// 删除类弹窗 可直接禁用按钮
				loading.value = true
	
				submitHandle()
				e.stopPropagation();
			}
		}
	}
	
	function submitHandle() {
		proxy.$emit('sureHandle')
		// 二次确认类弹窗 可直接禁用按钮
		loading.value = true
	}
	
	onUnmounted(() => {
		useUserStore().isModal = false
		window.removeEventListener('keydown', keyDown, true)
	})
	
	onMounted(() => {
		// 当前是弹窗
		useUserStore().isModal = true
		// 绑定监听事件
		window.addEventListener('keydown', keyDown, true)
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

</style>